<a [routerLink]="['/dialogues']" routerLinkActive="active" class="dialogues_link">
  <span
    class="count"
    *ngIf="(unreadMessagesCount$ | async)"
  ></span>

  <img src="assets/images/dialog-link.svg" alt="dialog">
</a>
